(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-product-form"] && !Shopify.designMode) return;
  try {
    
  const europeanEuroFormat = new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
  });
  const shippingCosts = 7.95; // Price in Euros
  const freeShippingPrice = 200.00; // Price in Euros
  const productLines = document.querySelectorAll('[id^="B2BForm-product-line-"]');
  const shippingCostField = document.querySelector('[id=current-shipping-costs]');
  const grandTotalField = document.querySelector('[id=current-grand-total]');
  const subTotalField = document.querySelector('[id=current-total-excluding-tax]');
  const lowTaxField = document.querySelector('[id=current-total-low-tax]');
  const highTaxField = document.querySelector('[id=current-total-high-tax]');

  const setFreeShipping = (shippingField) => {
    shippingField.innerText = europeanEuroFormat.format(0);
  }

  const setPaidShipping = (shippingField) => {
    shippingField.innerText = europeanEuroFormat.format(shippingCosts);
  }

  const calculateProductLineTotalPrice = (amountValue, productPrice, totalPriceField) => {
    const newPrice = (productPrice / 100) * amountValue;
    totalPriceField.innerText = europeanEuroFormat.format(newPrice);
    totalPriceField.dataset.productTotalPrice = newPrice;

    calculateSubtotalAndGrandtotal(productLines)
  };

  const calculatePrices = (productTotalPrice, taxType) => {
    if (taxType === 'low') {
      const priceIncludingTaxes = productTotalPrice * 1.09;
      const priceExcludingTaxes = productTotalPrice;
      const amountOfTax = priceIncludingTaxes - productTotalPrice;

      return {
        priceIncludingTaxes,
        priceExcludingTaxes,
        amountOfTax
      };
    }

    else {
      const priceIncludingTaxes = productTotalPrice * 1.21;
      const priceExcludingTaxes = productTotalPrice;
      const amountOfTax = priceIncludingTaxes - productTotalPrice;

      return {
        priceIncludingTaxes,
        priceExcludingTaxes,
        amountOfTax
      };
    }
  }

  const calculateSubtotalAndGrandtotal = (products) => {
    let grandTotal = 0;
    let subTotal = 0;
    let lowTaxTotal = 0;
    let highTaxTotal = 0;

    // Get all product line totals and calculate grand total
    for (let i = 0; i < products.length; i++) {
      const productLineTotal = Number(products[i].querySelector('[id=product-total-price]').dataset.productTotalPrice);
      const productTaxType = products[i].dataset.productTaxType;

      const prices = calculatePrices(productLineTotal, productTaxType);

      subTotal += prices.priceExcludingTaxes;
      if (productTaxType === 'low') lowTaxTotal += prices.amountOfTax;
      else highTaxTotal += prices.amountOfTax;
      grandTotal += prices.priceIncludingTaxes;
    }

    if (subTotal > freeShippingPrice) setFreeShipping(shippingCostField);
    else if (grandTotal <= freeShippingPrice) {
      setPaidShipping(shippingCostField);
      grandTotal += shippingCosts;
    }

    // Set inner text of grand total field to calculated result
    subTotalField.innerText = europeanEuroFormat.format(subTotal);
    lowTaxField.innerText = europeanEuroFormat.format(lowTaxTotal);
    highTaxField.innerText = europeanEuroFormat.format(highTaxTotal);
    grandTotalField.innerText = europeanEuroFormat.format(grandTotal);
  }

  for (let i = 0; i < productLines.length; i++) {
    const amountField = productLines[i].querySelector('[id^=B2BForm-product]');
    const totalPriceField = productLines[i].querySelector('[id^=product-total-price]');
    amountField.addEventListener('change', event => calculateProductLineTotalPrice(event.target.value, productLines[i].querySelector("[id^='product-price']").dataset.productPrice, totalPriceField));
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
